import React from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../../layouts/TextStyles'
import { courseExamApiSlice } from '../../../../features/course/courseExamSlice'
import ExamListTable from './components/ExamListTable'
import AddExamDialog from './components/AddExamDialog'

const ExamListPage = () => {
    const { courseId } = useParams()
    const { formatMessage } = useIntl()
    const {
        data: coursesExams = [],
        isFetching,
    } = courseExamApiSlice.useFetchCourseExamsByCourseIdQuery(Number(courseId))
    const [deleteCourseExam, { isLoading: isDeleting }] =
        courseExamApiSlice.useDeleteCourseExamMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteCourseExam(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) { }
    }

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'exams' })}</H3>
                    </Title>
                    <AddExamDialog courseId={Number(courseId)} />
                </Header>

                {(isDeleting || isFetching) && <LinearProgress />}

                {coursesExams && <ExamListTable
                    examsData={coursesExams}
                    onDelete={handleDelete}
                />}
            </Content>
        </Wrapper>
    )
}

export default ExamListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
